import { render } from "./addImage.vue?vue&type=template&id=6fab92a4&scoped=true"
import script from "./addImage.vue?vue&type=script&lang=ts"
export * from "./addImage.vue?vue&type=script&lang=ts"

import "./addImage.vue?vue&type=style&index=0&id=6fab92a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6fab92a4"

export default script